import * as yup from "yup";
import { FileTypeEnum } from "../../graphql/graphql";
import { Max, Min, Validation } from "../../utils/Validation.utils";
export const FileUploadInitialValues = {
    name: "",
    fileType: FileTypeEnum.PdfUpload,
    fileName: "",
    contentType: "",
    tags: [],
    isShared: false
};
export const FileUploadSchema = yup.object().shape({
    name: yup
        .string()
        .min(Min.Name, Validation.Min)
        .max(Max.Name, Validation.Max)
        .required(Validation.Required),
    fileType: yup
        .string()
        .oneOf(Object.values(FileTypeEnum), "Please select a valid file type")
        .required(Validation.Required),
    fileName: yup.string().required(Validation.Required),
    contentType: yup.string().required(Validation.Required),
    tags: yup.array().of(yup.string())
});
